import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";
import { useLocation } from 'react-router-dom';
import { faBalanceScale, faTimes, faCheck, faExclamationTriangle, faInfoCircle, faStar,faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import HomeSkeletonLoader from './SkeletonLoader/HomeSkeletonLoader';
import Tile from './images/tilesicon.png';
import Door from './images/doorsicon.png';
import Window from './images/windowsicon.png';
import Doorcolored from './images/Doorcolored.png';
import Windowcolored from './images/Windowcolored.png';
import Header from './Component/Header';
import Building from './images/Building.png';
import TileAllied from './images/tileallied.png';
import WaterProof from './images/waterproof.png';
import Paint from './images/paint.png';
import QuoteIcon from './images/quoteicon.png';
import TrashIcon from './images/binicon.png';
import ComparePopup from './Compare';
import MenuFooter from './Component/MenuFooter';

const Home = () => {
   const location = useLocation();
   //console.log(location)
   const p = location.state?.project?._id || location?.state?.p
//console.log(p)
  const [projects, setProjects] = useState([]);
  const [project , setProject] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [productCategories, setProductCategories] = useState([]);
  //console.log('Product Categories:', productCategories);
  const [categoryIds, setCategoryIds] = useState({
    windows: '',
    tiles: '',
    doors: '',
    adhesives: '',
  });
  const searchParams = new URLSearchParams(location.search);
  const ProjectId = searchParams.get('project') || sessionStorage.getItem('ProjectId') || p;
 //console.log('Project Params',searchParams.get('project'));
 //console.log('Project session',sessionStorage.getItem('ProjectId'));
  const customerId = searchParams.get('customer');
  //console.log(customerId);
  const urlToken = searchParams.get('token');
  const [blocksData, setBlocksData] = useState({});
  const [flatsData, setFlatsData] = useState({});
  ///console.log(blocksData)
  const navigate = useNavigate();
  const [packages, setPackages] = useState([]);
const [quotations, setQuotations] = useState({});
console.log('Quotations:', quotations);
const [isImageOpen, setIsImageOpen] = useState(false);
const [showAllQuotations, setShowAllQuotations] = useState(false);
const [activeTab, setActiveTab] = useState('packages');
const imageUrl = process.env.REACT_APP_FORE_MEASURIT_UIIMAGEURL;
const [selectedCategory, setSelectedCategory] = useState(null);
const [selectedCategoryName , setSelectedCategoryName] = useState(null);
//console.log(selectedCategoryName)
const [selectedPackage, setSelectedPackage] = useState(null);
const [isPackageSwitching, setIsPackageSwitching] = useState(false);
const [isQuotationLoading, setIsQuotationLoading] = useState(false);
const categoryOrder = ['Tiles', 'Doors', 'Windows'];
// const isRefreshing = useRefreshHandler(); 
const [isLoadingPackage, setIsLoadingPackage] = useState(true);
const [expandedItems, setExpandedItems] = useState({});
const [showComparePopup, setShowComparePopup] = useState(false);
const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [quotationToDelete, setQuotationToDelete] = useState(null);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const [showerrorpopup, setShowErrorPopup] = useState('');
  const [lastSelectedCategory, setLastSelectedCategory] = useState(() => {
    return sessionStorage.getItem('lastSelectedCategory') || null;
  });
  

useEffect(() => {
  if (urlToken) {
    try {
      const decodedToken = jwtDecode(urlToken);
      if(decodedToken){
        sessionStorage.setItem('token', urlToken);
        sessionStorage.setItem('userId', decodedToken.userId);
        sessionStorage.setItem('username', decodedToken.username);
        sessionStorage.setItem('roleId', decodedToken.roleId);
        sessionStorage.setItem('organizationId', decodedToken.organizationId);
        sessionStorage.setItem('customerId', customerId);
        sessionStorage.setItem('ProjectId', ProjectId); // Added ProjectId to session storage
      }
    } catch (error) {
      console.error('Error decoding token:', error);
    }
  }
}, [urlToken, searchParams, ProjectId, customerId]);


useEffect(() => {
  setIsLoading(true);
  setIsLoadingPackage(true);
  
  if (urlToken) {
    try {
      sessionStorage.setItem('token', urlToken);
      sessionStorage.setItem('customerId', customerId);
      fetchProjects();
      fetchProductCategories();
      fetchBlocksByProjectid(ProjectId);
    } catch (error) {
      console.error('Error during token-related operations:', error);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
        setIsLoadingPackage(false);
      }, 1000);
    }
  } else {
    const storedToken = sessionStorage.getItem('token');
    if (storedToken) {
      fetchProjects();
      fetchProductCategories();
      fetchBlocksByProjectid(ProjectId);
    }

    setTimeout(() => {
      setIsLoading(false);
      setIsLoadingPackage(false);
    }, 1000);
  }
}, [urlToken, customerId, ProjectId]);


 useEffect(() => {
     fetchProject();
     fetchPackagesByProjectId();
     //fetchProjects();
     //fetchPackagesByCustomerid();
     fetchProductCategories();
     fetchBlocksByProjectid();
     fetchFlatsByBlockid();
   }, []);

 
   useEffect(() => {
    if (selectedCategory) {
      handlegetQuote(selectedCategory);
    }
  }, [selectedCategory, ProjectId]);

  useEffect(() => {
    if (productCategories.length > 0) {
      // First check if there's a previously selected category in session storage
      const savedCategoryId = sessionStorage.getItem('lastSelectedCategory');
      
      if (savedCategoryId && productCategories.some(cat => cat._id === savedCategoryId)) {
        // If we have a saved category and it exists in our current categories, use it
        setSelectedCategory(savedCategoryId);
      } else {
        // Otherwise fall back to the default behavior
        const tilesCategory = productCategories.find(cat => 
          cat.product_category_name === 'Tiles'
        );
        
        if (tilesCategory) {
          setSelectedCategory(tilesCategory._id);
        } else if (productCategories.length > 0) {
          setSelectedCategory(productCategories[0]._id);
        }
      }
    }
  }, [productCategories]);

  //  this useEffect to update selectedCategoryName whenever selectedCategory changes
useEffect(() => {
  if (selectedCategory && productCategories.length > 0) {
    const category = productCategories.find(cat => cat._id === selectedCategory);
    if (category) {
      setSelectedCategoryName(category.product_category_name);
    }
  }
}, [selectedCategory, productCategories]);


  const handleCategorySelection = (categoryId) => {
    setSelectedCategory(categoryId);
    sessionStorage.setItem('lastSelectedCategory', categoryId);
    handlegetQuote(categoryId);
  };


  const fetchProjects = async () => {
    try {
      const token = sessionStorage.getItem('token');
     // console.log(token);
      const customerId = await sessionStorage.getItem('customerId');
      
      const response = await fetch(`${process.env.REACT_APP_FORE_APILINK}/projects/get-projects-by-customer?customer_id=${customerId}`, {
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        }
      });
      
      const data = await response.json();
      const sortedProjects = data?.data?.sort((a, b) => {
        const dateA = new Date(a.timestamp).getTime();
        const dateB = new Date(b.timestamp).getTime();
        return dateB - dateA;
      });
      
      //console.log('Sorted dates:', sortedProjects.map(p => ({ id: p._id, timestamp: p.timestamp })));
      setProjects(sortedProjects || []);
      sortedProjects.forEach(project => {
        fetchBlocksByProjectid(project._id);
      });
    } catch (error) {
      console.error('Error fetching projects:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchProject = async () => {
    try {
      const token = sessionStorage.getItem('token');    
      const response = await fetch(`${process.env.REACT_APP_FORE_APILINK}/projects/get-project?projectId=${ProjectId}`, {
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        }
      });
      
      const data = await response.json();
     //console.log(data);
      setProject(data|| []);
        fetchBlocksByProjectid(data._id);
    } catch (error) {
      console.error('Error fetching projects:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchBlocksByProjectid = async (projectId) => {
    try {
      const token = await sessionStorage.getItem('token');
      
      const response = await fetch(`${process.env.REACT_APP_FORE_APILINK}/blocks/get-all-blocks-of-project?projectId=${projectId}`, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'x-token': token
        },
      });
  
      const data = await response.json();
      //console.log(data);
      // Store blocks data
      setBlocksData(data);
 
      return data;
      
    } catch (error) {
      console.error('Failed to fetch blocks:', error);
      return null;
    }
  };

  const fetchPackagesByProjectId = async () => {
    try {
      const token = await sessionStorage.getItem('token');

      const response = await fetch(`${process.env.REACT_APP_FORE_APILINK}/Summary/get-packages-by-project?project_id=${ProjectId}`, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'x-token': token
        },
      });
  //console.log(response);
      const data = await response.json();
      //console.log('packages data ' , data);
      setPackages(data);  
      //console.log('packages data ' , data);
      return data;
      
    } catch (error) {
      console.error('Failed to fetch packages:', error);
      return null;
    }
  };  
  
  const fetchFlatsByBlockid = async (blockId) => {
    try {
      const token = await sessionStorage.getItem('token');
      const response = await fetch(`${process.env.REACT_APP_FORE_APILINK}/flats/get-flats-by-blockId?blockId=${blockId}`, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'x-token': token
        },
      });
  
      const data = await response.json();
    //console.log(data);
      setFlatsData(prev => ({
        ...prev,
        [blockId]: data
      }));
      return data;
    } catch (error) {
      console.error('Failed to fetch:', error);
    }
  };
  

 const fetchProductCategories = async () => {
  try {
    const token = await sessionStorage.getItem('token');
    // Fetch all categories including e-commerce categories
    const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}product-category/get-all-productCategories`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token,
      },
    });
    const data = await response.json();
    console.log('product categories:', data);
       
    if (data.data) {
      const categories = data.data;
      const ids = {
        windows: categories.find(cat => cat.product_category_name.toLowerCase() === 'windows')?._id,
        tiles: categories.find(cat => cat.product_category_name.toLowerCase() === 'tiles')?._id,
        doors: categories.find(cat => cat.product_category_name.toLowerCase() === 'doors')?._id,
        adhesives: categories.find(cat => cat.product_category_name.toLowerCase() === 'adhesives')?._id,
        tileAllied: categories.find(cat => 
          cat.product_category_name.toLowerCase() === 'tile allied products' 
        )?._id,
        waterproofing: categories.find(cat => 
          cat.product_category_name.toLowerCase() === 'waterproofing chemicals'
        )?._id,
        paints: categories.find(cat => 
          cat.product_category_name.toLowerCase() === 'paints & accessories'
        )?._id,
      };
      setCategoryIds(ids);
      setProductCategories(data.data);
    }
  } catch (error) {
    console.error('Failed to fetch product categories:', error);
  }
};


  const handlegetQuote = async (categoryId) => {
    //console.log('Fetching quote groups for category:', categoryId);
  
    // First, set the selected category immediately to update the UI
    setSelectedCategory(categoryId);
    
    // Clear previous quotations data or set loading state
    setQuotations(prev => ({
      ...prev,
      standard: [],
      customized: []
    }));
  
    try {
      const token = await sessionStorage.getItem('token');
      
      // Check if categoryId is valid before making the request
      if (!categoryId) {
        console.log('Invalid category ID, skipping API call');
        return;
      }
      
      // Log the full URL for debugging
      const apiUrl = `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/quotations/get-quotations-by-project-and-category?projectId=${ProjectId}&product_category_id=${categoryId}`;
      //console.log('Fetching from URL:', apiUrl);
      
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        }
      });
      
      if (!response.ok) {
        // Log detailed error information
        console.error(`API Error: ${response.status} ${response.statusText}`);
        
        // For 404 errors specifically, set empty data but don't throw
        if (response.status === 404) {
          console.log('No quotations found for this category, setting empty data');
          setQuotations({
            categoryId: categoryId,
            standard: [],
            customized: []
          });
          return;
        }
        
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      const data = await response.json();
      console.log('Fetched quote data for category:', categoryId, data);
  
      if (data.data) {
        setQuotations({
          ...data.data,
          categoryId: categoryId
        });
      } else {
        // If no data is returned, set empty arrays
        setQuotations({
          categoryId: categoryId,
          standard: [],
          customized: []
        });
      }
    } catch (error) {
      console.log('Error fetching quote data:', error.message);
      
      // Set empty data on error
      setQuotations({
        categoryId: categoryId,
        standard: [],
        customized: []
      });
      
      // You might want to show an error message to the user
      // setErrorMessage('Failed to load quotations. Please try again later.');
    }
  };
  const handleTilesClick = async (project, /* packageId, */quotationId,categoryId,type) => { 
  //console.log('project ID:', project._id,type);
 // console.log('packageId:', packageId);

    const token = sessionStorage.getItem('token');
    const customerId = sessionStorage.getItem('customerId');

    navigate('/consumer/app/tilesstandardquotedetails', {
      state: {
        projectId: project._id,
        categoryId: categoryId,
        quotationId:quotationId,
        type:type
      }   
    });
    console.log('Tiles Clicked:', project._id, categoryId, quotationId, type) 

  }
    
/*     if (packageId === 1) {
      navigate('/consumer/app/tilesstandardquotedetails', {
        state: {
          projectId: project._id,
          categoryId: categoryId,
        }     
      });
    } else if (packageId === 2) {
      navigate('/consumer/app/tilesstandardquotedetails', {
        state: {
          projectId: project._id,
          categoryId: categoryIds.tiles,
          customerId,
          token,
          organizationId: project.organizationId,
          packageId,
          packages: packages.data
        }
      });
    } else if (packageId === 3) {
      navigate('/consumer/app/tilesstandardquotedetails', {
        state: {
          projectId: project._id,
          categoryId: categoryIds.tiles,
          customerId,
          token,
          organizationId: project.organizationId,
          packageId,
          packages: packages.data
        }
      });    
    } 
  };*/
  
  

  const handleDoorsClick = async (project, /* packageId, */ quotationId, categoryId,type) => {
   
    const pakageData= packages.data.filter(p=>p.product_category_id === categoryId)
    
    const token = await sessionStorage.getItem('token');
    const customerId = await sessionStorage.getItem('customerId');
    console.log('enterd to click the doors package ')
    navigate('/consumer/app/doorsstandardquotedetails', {
      state: {
        projectId: project._id,
        categoryId: categoryId,
        quotationId:quotationId,
        type:type,
        customerId,
        token,
        organizationId: project.organizationId,
        packages: packages.data
      }
    });
    };
  
  const handleWindowsClick = async (project, /* packageId, */quotationId,categoryId,type) => {
 
    
    const token = await sessionStorage.getItem('token');
    const customerId = await sessionStorage.getItem('customerId');

    navigate('/consumer/app/windowsstandardquotedetails', {
      state: {
        projectId: project._id,
        categoryId: categoryId,
        quotationId:quotationId,
        type:type
      }     
    });
  
    
/*     if (packageId === 1) {
      navigate('/consumer/app/windowQuote', {
        state: {
          projectId: project._id,
          categoryId: categoryIds.windows,
          customerId,
          token,
          organizationId: project.organizationId,
          packageId,  
          packages: packages.data 
   
        }     
      });
    } else if (packageId === 2) {
      navigate('/consumer/app/windowQuote', {
        state: {
          projectId: project._id,
          categoryId: categoryIds.windows,
          customerId,
          token,
          organizationId: project.organizationId,
          packageId,
          packages: packages.data
        }
      });
    } else if (packageId === 3) {
      navigate('/consumer/app/windowQuote', {
        state: {
          projectId: project._id,
          categoryId: categoryIds.windows,
          customerId,
          token,
          organizationId: project.organizationId,
          packageId,
          packages: packages.data
        }
      });    
    } */
  };

  const handleAdhesivesClick = async (project) => { 
    const token = await sessionStorage.getItem('token');
    const customerId = await sessionStorage.getItem('customerId');
    
     navigate('Adhesives', {
      projectId: project._id,
      categoryId: categoryIds.adhesives,
      customerId,
      token,
      organizationId: project.organizationId
    });
  };

  const handleQuotationClick = (quotation,type) => {
    setIsQuotationLoading(true); 

    const categoryName = productCategories.find(
      
      cat => cat._id === quotation.product_category_id
    )?.product_category_name;

console.log(type)
   
  
//console.log("category name:--",categoryName)
//console.log("product categories:---",productCategories)
//console.log("cat",cat)
//console.log("p",quotation.product_category_id)
    setTimeout(() => {

    if (categoryName?.toLowerCase() === 'windows') {
      navigate('/consumer/app/windowsstandardquotedetails', {
        state: {
          quotationId: quotation._id,
          type: type
        }
      });
    }else  if (categoryName?.toLowerCase() === 'doors') {
      navigate('/consumer/app/tilesstandardquotedetails', {
        state: {
          quotationId: quotation._id
        }
      });
    }else {
      navigate('/consumer/app/tilesstandardquotedetails', {
        state: {
          quotationId: quotation._id,
          type: type
        }
      });
     }
  }, 2000);
};
  
const handleDeleteQuotation = async (quotationId, event) => {
  event.stopPropagation(); // Prevent triggering the parent onClick that opens quotation details
  
  // Set the quotation ID to delete and show the confirmation popup
  setQuotationToDelete(quotationId);
  setShowDeleteConfirmation(true);
};

// Add a new function to handle the actual deletion
const confirmDeleteQuotation = async () => {
  try {
    const token = sessionStorage.getItem('token');
    const roleId = sessionStorage.getItem('roleId');
    const userId = sessionStorage.getItem('userId');
    const username = sessionStorage.getItem('username');
    
    const deleteUrl = `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/quotations/delete-quotation?quotation_id=${quotationToDelete}`;
    
    console.log('Sending DELETE request to:', deleteUrl);
    
    const response = await fetch(deleteUrl, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token,
        'x-role-id': roleId || '',
        'x-user-id': userId || ''
      },
      body: JSON.stringify({
        userRole: {
          name: 'Customer'
        },
        username: {
          name: username || 'Customer User'
        },
        userId: userId
      })
    });
    
    // Close the confirmation popup
    setShowDeleteConfirmation(false);
    
    if (response.ok) {
      // Remove the deleted quotation from state
      setQuotations(prev => ({
        ...prev,
        customized: prev.customized.filter(q => q._id !== quotationToDelete)
      }));
      
      // Show success popup
      setPopupMessage('Quotation deleted successfully');
      setShowSuccessPopup(true);
    } else {
      // Try to parse the response as JSON if possible
      let responseData;
      try {
        const responseText = await response.text();
        responseData = JSON.parse(responseText);
      } catch (e) {
        console.log('Response is not valid JSON');
      }
      
      // Show error popup
      setPopupMessage(`Failed to delete quotation: ${responseData?.message || 'Unknown error'}`);
      setShowErrorPopup(true);
    }
  } catch (error) {
    console.error('Exception occurred while deleting quotation:', error);
    
    // Close confirmation popup and show error popup
    setShowDeleteConfirmation(false);
    setPopupMessage('An error occurred while deleting the quotation');
    setShowErrorPopup(true);
  }
};

  const openInGoogleMaps = (address) => {
    const encodedAddress = encodeURIComponent(address);
    const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
    window.open(mapsUrl, '_blank');
  };


 
  

  const ImagePopup = ({ imageUrl, projectName, onClose }) => (
    <div 
      className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div className="relative max-w-4xl w-full">
        <img
          src={imageUrl}
          alt={projectName}
          className="w-full h-auto rounded-lg"
        />
        <button 
          className="absolute top-4 right-4 text-white bg-black/50 rounded-full p-2 hover:bg-black/70"
          onClick={onClose}
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  );

  const handlePackageClick = (project, /* packageId */quotationId, category,type) => {
    console.log(type)
    //const packageDetails = packages.data.find(pkg => pkg.package_id === packageId);
    //setSelectedPackage(packageDetails);
    setTimeout(() => {
    if (category.product_category_name === 'Tiles') {
      handleTilesClick(project, quotationId,category._id,type);
    } else if (category.product_category_name === 'Doors') {
      handleDoorsClick(project, quotationId, category._id,type);
    } else if (category.product_category_name === 'Windows') {
      handleWindowsClick(project, quotationId,category._id,type);
    }
  }, 500);
};

// For Economy Package (Reliable & Affordable)
const economyStyles = {
  card: "border-teal-200 hover:border-teal-400 hover:shadow-teal-100",
  badge: "bg-gradient-to-r from-teal-500 to-teal-600",
  title: "text-teal-700",
  price: "bg-teal-50 text-teal-700",
  button: "bg-teal-600 hover:bg-teal-700 text-white"
};

// For Value Package (Popular Choice)
const valueStyles = {
  card: "border-violet-200 hover:border-violet-400 hover:shadow-violet-100 scale-105",
  badge: "bg-gradient-to-r from-violet-500 to-violet-600",
  title: "text-violet-700",
  price: "bg-violet-50 text-violet-700",
  button: "bg-violet-600 hover:bg-violet-700 text-white"
};

// For Premium Package (Luxury Experience)
const premiumStyles = {
  card: "border-amber-200 hover:border-amber-400 hover:shadow-amber-100",
  badge: "bg-gradient-to-r from-amber-500 to-amber-600",
  title: "text-amber-700",
  price: "bg-amber-50 text-amber-700",
  button: "bg-amber-600 hover:bg-amber-700 text-white"
};

// Apply these styles based on package_id:
const getPackageStyles = (packageId) => {
  switch(packageId) {
    case 1: return economyStyles;
    case 2: return valueStyles;
    case 3: return premiumStyles;
    default: return economyStyles;
  }
};

const handleNavigateToCategory = (categoryType) => {
  let categoryId, categoryName;
  
  switch(categoryType) {
    case 'tileAllied':
      categoryId = categoryIds.tileAllied;
      categoryName = 'Tile Allied Products';
      break;
    case 'waterproofing':
      categoryId = categoryIds.waterproofing;
      categoryName = 'Waterproofing Chemicals';
      break;
    case 'paints':
      categoryId = categoryIds.paints;
      categoryName = 'Paints & Accessories';
      break;
    default:
      console.error('Unknown category type:', categoryType);
      return; // Exit if category type is unknown
  }
  
  navigate('/consumer/productdetails', {
    state: {
      projectId: ProjectId,
      project: project,
      categoryId: categoryId,
      categoryName: categoryName,
    }
  });
  
  console.log(`Navigating to ${categoryName} with category ID:`, categoryId);
};

 return (
  <div className="bg-white min-h-screen">
    {(isLoading || isLoadingPackage) ? (
      <HomeSkeletonLoader />
    ) : (
      <>
        {/* Header with BB logo and hamburger menu */}
        <div className="w-full px-4 py-4 sticky top-0 z-10 border-b border-gray-200 bg-white">
          <div className="flex items-center">
            <FontAwesomeIcon
              icon={faArrowLeft}
              className="w-5 h-5 text-gray-600 mr-4 cursor-pointer"
              onClick={() => navigate(-1)}
            />
            <h1 className="text-[#0D0C0C] font-semibold text-xl">Quotations</h1>
          </div>
        </div>

        {/* Project Info Section */}
        {/* <div className="flex items-center p-4 bg-[#F5F5F5] rounded-lg shadow-sm border-1 border-[#E0D9D9] hover:shadow-md transition-shadow">
          <div className="w-16 h-16 rounded-full overflow-hidden border-2 border-gray-50 shadow-md flex items-center justify-center bg-white mr-4 flex-shrink-0">
            <img src={Building} alt="Building" className="w-14 h-14 object-contain" />
          </div> */}
          
          {/* Project Details - Middle section with flex-grow */}
          {/* <div className="flex-grow min-w-0 mr-4">
            <h2 className="text-lg font-medium text-gray-900 mb-1 truncate">{project?.projectName}</h2>
            <p className="text-sm text-gray-600 truncate hover:text-gray-800 transition-colors">
              <svg className="w-4 h-4 inline-block mr-1 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              {project?.siteAddress}
            </p>
          </div> */}
          
          {/* Stats - Right section */}
          {/* <div className="flex flex-col items-center space-y-2 flex-shrink-0">
            <div className="flex items-center bg-[#E0D9D9] px-2 py-1.5 rounded-md">
              <span className="font-medium text-xs">{blocksData[0]?.numFloors || '--'} Floors</span>
            </div>
            <div className="flex items-center bg-[#E0D9D9] px-2 py-1.5 rounded-md">
              <span className="font-medium text-xs">{blocksData[0]?.numFlats || '--'} Flats</span>
            </div>
          </div> */}
        {/* </div> */}

        {/* Categories and Quotations Section - Only show if quotations exist */}
       {/* Categories and Quotations Section - Show if quotations exist OR show no data message */}
{(quotations?.standard?.length > 0 || quotations?.customized?.length > 0) ? (
  <div className="border border-gray-200 rounded-lg shadow-sm mb-6">
    {/* Categories Section */}
    <div className='p-4'>
      <p className='mb-3 text-md font-semibold'>Category</p>
      <div className="grid grid-cols-3 gap-4">
        {productCategories
          .filter(pc =>
            pc.product_category_name.toLowerCase() === "windows" ||
            pc.product_category_name.toLowerCase() === "tiles" ||
            pc.product_category_name.toLowerCase() === "doors"
          ).sort((a, b) => {
            const aIndex = categoryOrder.indexOf(a.product_category_name);
            const bIndex = categoryOrder.indexOf(b.product_category_name);
            if (aIndex !== -1 && bIndex !== -1) {
              return aIndex - bIndex;
            }
            if (aIndex !== -1) return -1;
            if (bIndex !== -1) return 1;
            return 0;
          }).map(category => {
            let imageSrc;
            if (category.product_category_name.toLowerCase() === 'tiles') {
              imageSrc = Tile;
            } else if (category.product_category_name.toLowerCase() === 'doors') {
              imageSrc = Door;
            } else if (category.product_category_name.toLowerCase() === 'windows') {
              imageSrc = Window;
            } else {
              imageSrc = Tile;
            }

            const isSelected = selectedCategory === category._id;

            return (
              <div
                key={category._id}
                className="flex flex-col items-center cursor-pointer hover:bg-gray-50 p-2 rounded-md transition-colors duration-200"
                onClick={() => handleCategorySelection(category._id)}
              >
                <div
                  className={`relative w-24 h-24 flex flex-col items-center justify-center mb-3 rounded-full transition-all duration-200 ${
                    selectedCategory === category._id
                      ? 'border-2 border-gray-300 bg-gray-100'
                      : ''
                  }`}
                >
                  <img
                    src={imageSrc}
                    alt={category.product_category_name}
                    className={`w-12 h-12 object-contain transition-all duration-200 ${
                      selectedCategory !== category._id ? 'filter grayscale opacity-60' : ''
                    }`}
                  />

                  <span
                    className={`text-sm font-medium mt-1 text-center
                    ${isSelected ? 'font-bold' : 'text-gray-700'}`}
                  >
                    {category.product_category_name}
                  </span>

                  {/* Show red circle with white tick if this category is selected */}
                  {isSelected && (
                    <div className="absolute top-2 right-3 translate-x-1/3 -translate-y-1/3 bg-[#D64541] w-4 h-4 rounded-full flex items-center justify-center shadow">
                      <svg
                        className="w-3 h-3 text-white"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="3"
                        viewBox="0 0 24 24"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
      </div>
    </div>

    {/* separator */}
    <div className='border-t border-[#E0D9D9]'></div>

    {/* Quotations Grid starts - My Saved Quotes */}
    {quotations?.customized?.filter(q => q.project_id === project._id).length > 0 && (
      <div className="p-4 mb-8 mt-2">
        <h1 className='text-xl text-[#D64541] font-bold'>
          {productCategories.find(cat => cat._id === selectedCategory)?.product_category_name || 'Tiles'} Quotations
        </h1>
        <div className="flex items-center mt-2 mb-2">
          <h2 className="text-md font-medium text-gray-800">My Saved Quotes</h2>
          {quotations?.customized && (
            <span className="bg-[#D64541] rounded-full px-1 ml-2 text-white text-xs font-medium">
              {quotations.customized.length}
            </span>
          )}
        </div>
        <div className="space-y-2 max-w-[98%] mx-auto">
          {quotations?.customized
            ?.filter(q => q.project_id === project._id)
            .sort((a, b) => new Date(b.quotation_date) - new Date(a.quotation_date))
            .slice(0, showAllQuotations ? undefined : 2)
            .map((quotation, index, filteredArray) => {
              const latestDate = Math.max(
                ...filteredArray.map(q => new Date(q.quotation_date).getTime())
              );
              const isNewest = new Date(quotation.quotation_date).getTime() === latestDate;

              return (
                <div
                  key={quotation._id}
                  className={`border border-gray-300 relative bg-white p-3 rounded-md transition-all duration-300 cursor-pointer
                    ${quotation.selected
                      ? 'border-2 border-[#D64541] shadow-sm'
                      : 'border border-gray-100 hover:border-red-200'}`}
                  onClick={() => handleQuotationClick(quotation, 'customized quotation')}
                >
                  {quotation.selected && (
                    <div className="absolute -top-3 -left-1">
                      <div className="bg-green-500 text-white text-[10px] font-medium px-3 py-1 rounded-full shadow-sm flex items-center gap-1.5">
                        <div className="w-1 h-1 rounded-full bg-white animate-pulse"/>
                        Interested
                      </div>
                    </div>
                  )}

                  {isNewest && (
                    <div className="absolute -top-0 -right-0">
                      <div className="bg-[#F5F5F5] text-gray-500 text-[10px] font-medium px-2 py-0.5 rounded-md shadow-sm flex items-center gap-1.5">
                        <div className="w-1.5 h-1.5 rounded-full bg-[#D64541] animate-pulse"/>
                        New
                      </div>
                    </div>
                  )}

                  <div className="flex items-center mt-2">
                    <div className="flex items-center gap-3 w-1/2">
                      <div className={`w-10 h-10 rounded-xl flex-shrink-0 flex items-center justify-center transition-colors
                        ${quotation.selected ? 'bg-gradient-to-br from-red-50 to-red-100' : 'bg-white'}`}
                      >
                        <img
                          src={QuoteIcon}
                          alt={'quote'}
                          className={'w-12 h-12 object-contain transition-all duration-200'}
                        />
                      </div>
                      <div className="min-w-0 flex-1">
                        <div className="flex items-center">
                          <span className="text-sm font-semibold text-gray-800 truncate">
                            {quotation?.quotation_number}
                          </span>
                        </div>
                        <span className="text-xs text-gray-500 mt-0.5 block">
                          {new Date(quotation?.quotation_date).toLocaleDateString()}
                        </span>
                      </div>
                    </div>

                    <div className="w-1/2 text-right">
                      <span className={'text-lg text-[#D64541] font-bold'}>
                        ₹{Math.round(quotation?.subtotal || 0).toLocaleString('en-IN')}/-
                      </span>
                    </div>

                    <div className="flex justify-end items-end w-1/6 relative h-full">
                      {/* Delete icon positioned at the bottom right within its container */}
                    </div>
                  </div>
                  <div
                    className="absolute bottom-2.5 -right-2.5 text-red-600 hover:bg-red-50 rounded-full transition-colors p-1"
                    onClick={(e) => handleDeleteQuotation(quotation._id, e)}
                    title="Delete quotation"
                    style={{ transform: 'translateY(10px)' }}
                  >
                    <img src={TrashIcon} alt="Delete" className="w-10 h-6" />
                  </div>
                </div>
              );
            })}

          {/* Show More/Less Button */}
          {quotations?.customized?.filter(q => q.project_id === project._id).length > 2 && (
            <button
              onClick={() => setShowAllQuotations(!showAllQuotations)}
              className="w-full mt-2 py-2 text-sm font-medium bg-red-50 text-red-600 rounded-lg transition-colors"
            >
              {showAllQuotations ? 'Show Less' : 'Show More'}
            </button>
          )}
        </div>
      </div>
    )}

    {/* separator */}
    <div className='border-t border-[#E0D9D9]'></div>

    {/* Standard Quotations Section - Only show if quotations exist */}
    {quotations && quotations?.standard?.length > 0 && (
      <>
        <div className="p-4 relative">
          <h2 className="text-lg font-medium text-gray-800 mb-2">Suggested Quotes by
            <span className='ml-1 font-bold'>Brickbucket</span>
          </h2>

          {/* Standard Quotations content */}
          <div className="mt-5">
            {selectedCategory && (
              <div className="space-y-6">
                {quotations?.standard?.map(pkg => {
                  return (
                    <div key={pkg._id} className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm hover:shadow-md transition-all duration-300">
                      {/* Package Header */}
                      <div className="relative px-5 py-4">
                        {/* Selected Badge */}
                        {pkg.selected && (
                          <div className="absolute top-4 left-4 flex items-center gap-1.5 rounded-full shadow-sm px-3 py-1 bg-[#D64541]">
                            <div className="flex items-center gap-1">
                              <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse"/>
                              <span className="text-white text-xs font-medium">Interested</span>
                            </div>
                          </div>
                        )}

                        <div className="flex justify-between items-center">
                          <div>
                            <h3 className="text-xl font-bold text-gray-800">
                              {pkg.package_name}
                            </h3>
                            <div className="mt-1 text-xs font-medium text-gray-800">
                              {pkg.package_id === 1 && "Economy Choice"}
                              {pkg.package_id === 2 && "✨ Best Value"}
                              {pkg.package_id === 3 && "★ Premium"}
                            </div>
                          </div>
                          <div className="text-xl font-bold px-4 py-2 rounded-xl bg-gray-100 text-[#D64541]">
                            ₹{Math.round(pkg.total).toLocaleString('en-IN')}/-
                          </div>
                        </div>
                      </div>

                      {/* View Details Button - Always visible */}
                      <div className="w-full p-2">
                        <button
                          onClick={() => handlePackageClick(
                            project,
                            pkg._id,
                            productCategories.find(cat => cat._id === selectedCategory),
                            "Standard Quotation"
                          )}
                          className="bg-gray-100 w-full py-2 border border-gray-300 text-black rounded-md text-sm font-medium
                            transition-all duration-300 flex items-center justify-center gap-2
                            shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
                        >
                          View Details
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>

        {/* Compare Button - Only show if standard quotations exist */}
        <div className='p-2 flex justify-end'>
          <button
            onClick={() => setShowComparePopup(true)}
            className='flex items-center gap-2 px-4 py-2 bg-[#D64541] text-white rounded-full text-sm font-semibold transition-all duration-200 ease-in-out shadow-md hover:bg-[#A00A0A] hover:shadow-lg animate-pulse-continuous'
          >
            <FontAwesomeIcon icon={faBalanceScale} className="text-white" />
            <span>Compare Quotations</span>
          </button>
        </div>
      </>
    )}

    {/* CSS Animation */}
    <style jsx>{`
      @keyframes pulse-continuous {
        0% {
          transform: scale(1);
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
        }
        50% {
          transform: scale(1.03);
          box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
        }
        100% {
          transform: scale(1);
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
        }
      }
      .animate-pulse-continuous {
        animation: pulse-continuous 1.5s ease-in-out infinite;
      }
    `}</style>
  </div>
) : (
  /* No Quotations Found Message */
  <div className="flex flex-col items-center justify-center py-16 px-4">
    <div className="text-center">
            <div className="w-24 h-24 mx-auto mb-6 bg-gray-100 rounded-full flex items-center justify-center">
        <svg className="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      </div>
      <h3 className="text-xl font-semibold text-gray-800 mb-2">No Quotations Found</h3>
      <p className="text-gray-600 text-sm max-w-sm mx-auto">
        There are currently no quotations available for this project.
      </p>
    </div>
  </div>
)}


        {/* Loading Overlay */}
        {isQuotationLoading && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="h-16 w-16 relative">
              <div className="h-8 w-8 rounded-full border-4 border-t-[#C20C0C] border-r-[#C20C0C] border-b-transparent border-l-transparent animate-spin"></div>
            </div>
          </div>
        )}

        {/* Delete Confirmation Modal */}
        {showDeleteConfirmation && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl p-6 max-w-md w-full mx-4">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Confirm Deletion</h3>
              <p className="text-gray-600 mb-6">Are you sure you want to delete this quotation?</p>
              <div className="flex justify-end gap-3">
                <button
                  onClick={() => setShowDeleteConfirmation(false)}
                  className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 transition-colors"
                >
                  No
                </button>
                <button
                  onClick={confirmDeleteQuotation}
                  className="px-4 py-2 bg-[#D64541] text-white rounded-md hover:bg-red-700 transition-colors"
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Compare Popup */}
        <ComparePopup
          isOpen={showComparePopup}
          onClose={() => setShowComparePopup(false)}
          quotations={quotations}
          project={project}
          productCategories={productCategories}
          onViewDetailsClick={handlePackageClick}
          selectedCategoryName={selectedCategoryName}
        />

        {/* Additional CSS Animation */}
        <style jsx>{`
          @keyframes slide-up {
            from {
              transform: translateY(100%);
            }
            to {
              transform: translateY(0);
            }
          }
          
          .animate-slide-up {
            animation: slide-up 0.3s ease-out forwards;
          }
        `}</style>
      </>
    )}
    <MenuFooter />
  </div>
);

};

export default Home;